import { Component, inject, input } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { TranslateModule } from '@ngx-translate/core';
import { BottomSheetConfig, MatDialogTransportListData } from 'src/app/interfaces/mat.interface';
import { BreakpointsService } from 'src/app/services/breakpoints.service';
import { AllTransportListComponent } from '../../../../../../../all-transport-list/all-transport-list.component';
import { Transport } from 'src/app/pages/custom-route/interfaces/custom-route.interface';
import { CustomRouteService } from 'src/app/pages/custom-route/services';

@Component({
  selector: 'app-stop-details',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './stop-details.component.html',
  styleUrls: ['./stop-details.component.scss'],
})
export class StopDetailsComponent {
  public transportList = input<Transport[]>();
  public transport = input.required<Transport>();
  public pointTitle = input.required<string>();
  public previousPointTitle = input.required<string>();
  
  private _breakpointsService = inject(BreakpointsService);
  private _bottomSheet = inject(MatBottomSheet);
  private _customRouteService = inject(CustomRouteService);
  
  private _isMobile = this._breakpointsService.isMobile;
  private _notSaturatedPoints = this._customRouteService.noSaturedPoints;

  public handleClickSeeStopDetails(): void {
    if (this._isMobile()) {
      this.openBottomSheetTransportListMobile();
    } else {
      this.openBottomSheetTransportListDesktop();
    }
  }
  
  public openBottomSheetTransportListMobile(): void {
      const bottomSheetConfig: BottomSheetConfig<AllTransportListComponent, MatDialogTransportListData> = {
        component: AllTransportListComponent,
        data: {
          transportList: this.transportList(),
          transportId: this.transport().id,
          pointTitle: this.pointTitle(),
          previousPointTitle: this.previousPointTitle(),
        },
        panelClass: 'all-transport-list-bottom-sheet--mobile',
      }
      this._bottomSheet.open(AllTransportListComponent, bottomSheetConfig);
    }
      
    public openBottomSheetTransportListDesktop(): void {
      const bottomSheetConfig: BottomSheetConfig<AllTransportListComponent, MatDialogTransportListData> = {
        component: AllTransportListComponent,
        data: {
          transportList: this.transportList(),
          transportId: this.transport().id,
          pointTitle: this.pointTitle(),
          previousPointTitle: this.previousPointTitle(),
        },
        panelClass: 'all-transport-list-bottom-sheet--desktop' + (this._notSaturatedPoints() ? '-no-saturated-points' : ''),

      }
      this._bottomSheet.open(AllTransportListComponent, bottomSheetConfig);
    }
}
